import { useEffect, useState } from 'react';
import { Stack, Switch, Typography, CircularProgress } from '@mui/material';
import { apiget, apiput } from '../../service/api';

/**
 * Self-serve "Accepting new leads" toggle for the logged-in LO.
 *
 * Flipping it off immediately removes the LO from the round-robin
 * eligible pool. Existing assigned leads are untouched. Admins cannot
 * toggle this for someone else — it's a personal switch.
 *
 * Only rendered for users whose role can be assigned leads (checked by
 * the parent via localStorage.userRole).
 */
const AcceptingLeadsSwitch = () => {
  const [enabled, setEnabled] = useState(true);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      const res = await apiget('user/round-robin/me');
      if (res?.status === 200) setEnabled(res.data?.enabled !== false);
      setLoading(false);
    })();
  }, []);

  const handleToggle = async (e) => {
    const next = e.target.checked;
    setEnabled(next);
    setSaving(true);
    await apiput('user/round-robin/me', { enabled: next });
    setSaving(false);
  };

  if (loading) {
    return <CircularProgress size={18} />;
  }

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <Typography
        variant="body2"
        color={enabled ? 'success.main' : 'text.secondary'}
      >
        {enabled ? 'Accepting new leads' : 'Paused'}
      </Typography>
      <Switch
        checked={enabled}
        onChange={handleToggle}
        disabled={saving}
        size="small"
      />
    </Stack>
  );
};

export default AcceptingLeadsSwitch;
